import React from "react";
import ReactDataTable from "../../../components/ReactDataTable";
import useTimeSheetApi from "../../../api/timesheet";
import { skillsReportInterface } from "../../../model/timesheet";

const SkillsReportPage: React.FC = () => {
  const [SkillsReportList, setSkillsReportList] = React.useState<
    skillsReportInterface[] | null
  >([]);
  const { fetchEmployeeskillReport } = useTimeSheetApi();

  const excelSheetHeader: string[] = [
    "Employee Id",
    "Employee Name",
    "Competency Area",
    "Level",
    "Skills",
  ];

  const columns = [
    {
      name: "Employee Id",
      selector: (row: skillsReportInterface) => row.employee_id,
      sortable: true,
    },
    {
      name: "Employee Name",
      selector: (row: skillsReportInterface) => row.employee_name,
      sortable: true,
    },
    {
      name: "Competency Area",
      selector: (row: skillsReportInterface) => row.knowledge_name,
      sortable: true,
    },
    {
      name: "Level",
      selector: (row: skillsReportInterface) => row.level_name,
      sortable: true,
    },
    {
      selector: (row: skillsReportInterface) => row.selected_skills,
      name: "Skills",
      sortable: true,
    },
   
  ];



  const getSkillsReport = React.useCallback(async () => {
    try {
      const responseData = await fetchEmployeeskillReport();
      if (!responseData) return;
      setSkillsReportList(responseData as skillsReportInterface[]);
      return responseData;
    } catch (error) {
      // setError(error.message);
    }
  }, [fetchEmployeeskillReport]);

  React.useEffect(() => {
    getSkillsReport();
  }, []);

  return (
    <div>
      <ReactDataTable
        columns={columns}
        data={SkillsReportList ?? []}
        showFilter={SkillsReportList ? true : false}
        showExport={SkillsReportList ? true : false}
        actionOption={false}
        ReportName={"Employees_skills_report"}
        excelSheetHeader={excelSheetHeader}
      />
    </div>
  );
};

export default SkillsReportPage;
